import {store} from '../index' // Adjust the path to your store
import { setReload } from './globalReload';

export const triggerReload = () => {
  window.location.reload();
};
// Log whenever the store updates
